import * as React from "react";

import { useDataMutableSourceSuccessClientStorageData_asController } from "../data-mutable-source-success-client-storage-data";

import {
  useMyBagDataSourceIntersection,
  useMyBagTotalsDataSourceIntersection,
} from "../my-bag-provider";

export const CacheDataForTheSuccessPage: React.FunctionComponent = (props) => {
  const { latest: myBagData } = useMyBagDataSourceIntersection();
  const { latest: myBagTotalsData } = useMyBagTotalsDataSourceIntersection();

  const { handleLatestMyBagDataChange, handleLatestMyBagTotalsDataChange } =
    useDataMutableSourceSuccessClientStorageData_asController();

  React.useEffect(() => {
    if (myBagData) {
      handleLatestMyBagDataChange(myBagData);
    }
  }, [myBagData, handleLatestMyBagDataChange]);

  React.useEffect(() => {
    if (myBagTotalsData) {
      handleLatestMyBagTotalsDataChange(myBagTotalsData);
    }
  }, [myBagTotalsData, handleLatestMyBagTotalsDataChange]);
  return <React.Fragment>{props.children || []}</React.Fragment>;
};
